import { Component, OnInit } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { CodeSnippetService } from '@services/code-snippets/code-snippet.service';
import { PageAction } from '../../../components/page-actions/page-actions.component';

@Component({
    selector: 'app-code-snippets-edit',
    templateUrl: './code-snippets-edit.component.html',
    styleUrls: ['./code-snippets-edit.component.scss'],
    providers: [CodeSnippetService],
    standalone: false
})
export class CodeSnippetsEditComponent implements OnInit {
  public title = 'Create a new Code-Snippet';
  public subtitle: string;
  public pageActions: PageAction[];
  codeSnippet: Models.CodeSnippet;
  codeSnippetId: string;
  isLoading = false;
  options = { hideFields: false };

  constructor(public codeSnippetService: CodeSnippetService, private route: ActivatedRoute, private router: Router, private snackbar: SnackbarService) {
  }

  ngOnInit() {
    this.isLoading = true;
    this.codeSnippetId = this.route.snapshot.params['id'];
    !!this.codeSnippetId ? this.initExistingCodeSnippet() : this.initNewCodeSnippet();
    this.createPageActions();
  }

  async onSave() {
    if (this.codeSnippet.type !== 'scss') {
      this.codeSnippet.compiledCode = this.codeSnippet.code;
    }
    if (this.codeSnippet.type === 'json' && !this.testJson()) {
      return false;
    }
    const validation = await this.codeSnippet.validate(true);
    if (validation.success) {
      try {
        const result = await (this.codeSnippetId ? this.codeSnippetService.update(this.codeSnippetId, this.codeSnippet) : this.codeSnippetService.create(this.codeSnippet));
        this.codeSnippetId ? null : this.router.navigate(['code-snippets', result?._id, 'edit']);;
      } catch (e) {
        this.snackbar.error('Invalid Syntax: ' + e?.error?.message || e?.message, 50000);
      }
    } else {
      console.log(validation);
      this.snackbar.open('Could not create the Snippet, please fill in the form correctly');
    }
  }

  testJson() {
    try {
      JSON.parse(this.codeSnippet.code);
    } catch (e) {
      this.snackbar.error('Invalid JSON ! ' + e, 50000);
      return false;
    }
    return true;
  }

  private async initExistingCodeSnippet() {
    this.codeSnippet = await this.codeSnippetService.get(this.codeSnippetId);
    this.title = 'Edit Code-Snippet: ' + this.codeSnippet.title;
    this.subtitle = this.codeSnippet.type;
    this.isLoading = false;
  }

  private initNewCodeSnippet() {
    this.isLoading = false;
    this.codeSnippet = <Models.CodeSnippet>Models.ModelFactory.createModelInstanceByName('CodeSnippet');
    this.codeSnippet.code = null;
    this.isLoading = false;
  }

  private createPageActions(): void {
    this.pageActions = [
      new PageAction({ icon: 'subdirectory_arrow_left', title: 'Go to Overview', callback: () => { this.router.navigate(['code-snippets']); } }),
      new PageAction({ icon: 'format_paint', title: 'Detail View Code Snippet', callback: () => { this.router.navigate(['code-snippets/', this.route.snapshot.params['id']]); } }),
      new PageAction({ icon: 'save', title: 'Save',  callback: () => { this.onSave(); }  })
    ];
  }
}
